import { render, staticRenderFns } from "./InterfaceLegend.vue?vue&type=template&id=286f988c&scoped=true&"
import script from "./InterfaceLegend.vue?vue&type=script&lang=ts&"
export * from "./InterfaceLegend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f988c",
  null
  
)

export default component.exports